import React, { useMemo } from "react";
import { Navigate } from "react-router";
import { useUserInfo } from "../../hooks/useUserInfo";
import useSession from "../../hooks/useSession";
import { getAllowedTableauReports } from "../../utils/tableauConfig";


export default function Analytics() {
  const { parsedTenantAttribute, loadingInfo } = useUserInfo();
  const { rolesSet } = useSession();

  const firstReportPath = useMemo(() => {
    const allowedReports = getAllowedTableauReports(parsedTenantAttribute, rolesSet);
    return allowedReports[0]?.path;
  }, [parsedTenantAttribute, rolesSet]);


  if (loadingInfo) return <div>Loading…</div>;


  if (!firstReportPath) {
    return <div>No reports configured for this tenant.</div>;
  }

  return <Navigate to={`/analytics/reports/${firstReportPath}`} replace />;
}
